import React from 'react';

import { SkippedRecipient, SkippedReason } from 'utils/api/modules/entities/entities.types';

import { SkippedList, SkippedBox, SkippedScroll, SkippedRow, SkippedName, SkippedReasonText } from '../styles';

const REASON_LABELS: Record<string, string> = {
  [SkippedReason.Inactive]: 'Deactivated user',
  [SkippedReason.NoDocumentsLicence]: 'No Documents licence',
};

export const reasonLabel = (reason: string): string => REASON_LABELS[reason] || reason;

const SkippedRecipientsList: React.FunctionComponent<{ skipped: SkippedRecipient[] }> = ({ skipped }) => (
  <SkippedList>
    <SkippedBox>
      <SkippedScroll>
        {skipped.map((recipient) => (
          <SkippedRow key={recipient.uuid}>
            <SkippedName>{recipient.name}</SkippedName>
            <SkippedReasonText>{reasonLabel(recipient.reason)}</SkippedReasonText>
          </SkippedRow>
        ))}
      </SkippedScroll>
    </SkippedBox>
  </SkippedList>
);

export default SkippedRecipientsList;
